<div
  class="skeleton-loader"
  [ngStyle]="cssVariables"
  [class]="extraClassName"
></div>